<div class="bg-surface overflow-hidden sm:rounded-b-md">
  @if ((documents?.length || 0) > 0) {
    <ul role="list" class="divide-y divide-separator">
      <ng-content></ng-content>
    </ul>
  } @else {
    <div class="m-20 flex flex-col items-center text-sm text-fg-secondary min-h-">
      Keine Dokumente vorhanden
    </div>
  }
</div>
